module.exports = __webpack_public_path__ + "static/media/468x60_0052_en.042a8842.jpg";